/**
 *
 * key
 *
 */

 const key = 'bGVhZG9jY3VycmVk'

 export default key
 